import * as packageJson from '../../package'

window.frontendAppVersion = packageJson.version;

const env = 'prod';
const envConfig = {
  dev: {
    //apiUrl: 'https://wm02rlamkg.execute-api.eu-central-1.amazonaws.com/prod'
    // apiUrl: 'https://msnbe6avd8.execute-api.eu-central-1.amazonaws.com/test',
    apiUrl: 'http://localhost:8080/v1',
    loginUrl: 'https://test-lmit-cooperate-itlm-ping-p7aok5axaq-ew.a.run.app/sso/auth/?sso&redirectAfterLogin=' + encodeURIComponent('http://localhost:3000')
    //apiUrl: 'http://localhost:8080/v1'
  },
  test: {
    //apiUrl: 'https://moduloresiapi.test.cloud.leroymerlin.it/v1'
    apiUrl: 'https://lmit-returns-nprd-api-fjv6fqwg3a-ew.a.run.app',
    loginUrl: 'https://preprod-lmit-returns-nprd-ping-fjv6fqwg3a-ew.a.run.app/sso/auth/?sso&redirectAfterLogin=' + encodeURIComponent('https://moduloresi.test.cloud.leroymerlin.it')
  },
  prod: {
    //apiUrl: 'https://moduloresiapi.cloud.leroymerlin.it/v1'
    // apiUrl: 'https://msnbe6avd8.execute-api.eu-central-1.amazonaws.com/prod' // same test env API
    apiUrl: 'https://lmit-returns-prd-api-dtffxqzwnq-ew.a.run.app/v1',
    loginUrl: 'https://prod-lmit-cooperate-itlm-ping-p7aok5axaq-ew.a.run.app/sso/auth/?sso&redirectAfterLogin=' + encodeURIComponent('https://moduloresi.cloud.leroymerlin.it')
  }
}

export default envConfig[env]



// WEBPACK FOOTER //
// ./src/common/config.js